import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { pathTo } from '@navigation';

const useStyles = makeStyles(() => ({
  breadcrumbs: {
    display: 'flex',
  },
  item: {
    marginRight: '10px',
    margin: '0px',
    padding: '0px',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#444b62',
  },
  link: {
    textDecoration: 'none',
    color: '#838aa2',
  },
}));

const Breadcrumbs = ({ route }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <nav className={classes.breadcrumbs}>
      {pathTo(route)
        .filter((crumb) => !crumb.notBreadcrumb)
        .map((crumb, index, breadcrumbs) => (
          <h5 key={index} className={classes.item}>
            {index < breadcrumbs.length - 1 && (
              <Link className={classes.link} to={crumb.path}>
                {t(crumb.title)} /
              </Link>
            )}
            {index === breadcrumbs.length - 1 && t(crumb.title)}
          </h5>
        ))}
    </nav>
  );
};

Breadcrumbs.propTypes = {
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    showOnNav: PropTypes.bool.isRequired,
    component: PropTypes.node.isRequired,
  }).isRequired,
};

export default Breadcrumbs;
